// App.js
import React from "react";
import "./Header.css"; // Custom CSS
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Bootstrap JS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons";
import hotelLogo1 from "./image/hotellogo.png";
import { Link } from "react-router-dom";


function Header() {
  return (
    <div className="container-fluid m-0 p-0" id="hadderFix">
      <div className="row" id="hadderFix">
        <div className="col-sm-12">
          <div className="row">
            <div className="col-sm-2">
              <img
                src={hotelLogo1}
                id="mainLogo"
                className="img-fluid"
                alt="Hotel Logo"
              />
            </div>
            <div className="col-sm-10">
              <div className="row d-flex justify-content-center pt-2" id="tab">
                <div className="col-sm-4 text-center d-flex justify-content-center align-items-center">
                  <p id="project-name">Hotel Chitrakoot</p>
                </div>
                <div className="col-sm-6 text-center d-flex justify-content-center align-items-center">
                  <span className="me-3" id="sp">
                    <strong>
                      <FontAwesomeIcon icon={faPhone} />{" "}
                      <a
                        href="tel:+91-9621336440"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        +91-9305814274
                      </a>{" "}
                      &#8739;{" "}
                      <a
                        href="tel:+91-7652071957"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        +91-8081143880
                      </a>
                    </strong>
                  </span>
                  <span className="me-1" id="sp">
                    <strong>
                      <FontAwesomeIcon icon={faEnvelope} />{" "}
                      <a
                        href="mailto:hotelchkt@gmail.com"
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        hotelchkt@gmail.com
                      </a>
                    </strong>
                  </span>
                </div>
                <div className="col-sm-2 icon d-flex justify-content-center align-items-center">
                  <a href="#">
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                  <a href="https://web.whatsapp.com/send?phone=+91-8081143880">
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                  <a href="#">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0 p-0" id="bx" style={{boxShadow:'0px 8px 15px rgba(0, 0, 0, 0.3)'}}>
        <div className="col-sm-3"></div>
        <div className="col-sm-6 d-flex" id="ms">
          <div className="col-sm-1" id="s1"></div>
          {/* Navigation Bar Section */}
          <nav className="navbar navbar-expand-md navbar-custom" id="btn">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item mr-3">
                  <Link className="nav-link" to="/home">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/about">
                  About Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/Services">
                  Services
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/rooms">
                  Rooms
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/contact">
                    Contact Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/feedback">
                  Feedback
                  </Link>
                </li>
                <li className="nav-item" style={{paddingLeft:'8px'}}>
                  <Link className="nav-link" to="/gallary">
                    Gallary
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
          <div className="col-sm-1" id="s2"></div>
        </div>
        <div
          className="col-sm-1 text-center d-flex justify-content-center align-items-center"
          id="loginM"
        >
          <strong>
            <Link to="/login" id="login">
              <FontAwesomeIcon icon={faUserTie} /> &emsp;Login
            </Link>
          </strong>
        </div>
      </div>
    </div>
  );
}

export default Header;
